import React, { useEffect, useState, useContext, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Select from "react-select";
import { buildSelectedValued, buildSearchValue } from "helpers/searchHelper";
import { FilterContext } from "contextos/FilterContext";
import styles from "./SearchOptions.module.scss";
// import LinkList from "components/linkList/LinkList";

const SearchOptions = (props) => {
  const [options, setOptions] = useState({
    HasIsadg: false,
    loaded: false,
  });
  const [colection, setColection] = useState({});
  const [selectedValues, setSelectedValue] = useState([]);
  const [searchValues, setSearchValue] = useState([]);
  const [currentFocus, setcurrentFocus] = useState("");
  const [search] = useSearchParams();
  const { handleSubmit } = useContext(FilterContext);
  const timerId = useRef(null);

  const timerHandler = () => {
    clearTimeout(timerId.current);
    timerId.current = null;
    handleSubmit();
  };
  const onInputChange = () => {
    if (timerId.current) {
      clearTimeout(timerId.current);
    }
    timerId.current = window.setTimeout(timerHandler, 3000);
  };

  useEffect(() => {
    setOptions((prev) => ({ ...prev, loaded: props.loaded }));
    setColection(props?.colection);
    setSearchValue(buildSearchValue(props?.colection?.searchfields));
    setSelectedValue(buildSelectedValued(props?.colection?.searchfields));
  }, [props?.colection, props.loaded]);

  const handleAnswerChange = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  const saveValue = (newValue, name, type) => {
    if (type === "text" || type === "date") {
      setSearchValue((current) =>
        current.map((obj) => {
          if (obj.name === name) {
            return { ...obj, value: newValue };
          }
          return obj;
        })
      );
    } else {
      setSelectedValue((current) =>
        current.map((obj) => {
          if (obj.value === name) {
            return { ...obj, selectedValues: newValue };
          }
          return obj;
        })
      );
    }
  };

  useEffect(() => {
    if (colection?.searchfields) {
      colection?.searchfields.forEach((element) => {
        let urlValue = search.get(element.value);
        //console.log(element.value, urlValue);
        if (!urlValue) {
          return;
        }
        
        if (element?.type === "text") {
          saveValue(urlValue, element.value, "text");
          if (element.value === "isadg") {
            setOptions((prev) => ({ ...prev, HasIsadg: true }));
          }
        } else if (element?.type === "date") {
          saveValue(urlValue, element.value, "date");
        } else {
          urlValue = search.getAll(element?.value);
          let newValue = [];
          urlValue.forEach((urlElementValue) => {
            let valorOpcion = element.values.find(
              (opcion) => opcion.value === urlElementValue
            )?.label;
            if (!valorOpcion) {
              valorOpcion = urlElementValue;
            }
            newValue.push({ label: valorOpcion, value: urlElementValue });
          });
          saveValue(newValue, element.value, "select");
        }
      });
    }
  }, [search, colection]);

  const changeSelect = (valor) => {
    // const valor_anterior = selectedValues.find(
    //   (element) => element.value === valor
    // )?.selectedValues;
    // if (valor_anterior !== currentFocus) {
    // }
    handleSubmit();
  };

  return (
    <div>
      {options.loaded && (
        <div>
          {/* renderizando capos de texto */}
          {colection?.searchfields.map((field) => {
            return (
              <div className="col-12 form-group" key={field.value}>
                {field?.type === "text" && (
                  <div className="mt-3">
                    <label htmlFor="material" className={`${styles.title}`}>{`${field.displayText}`}</label>
                    <input
                      className={`${styles.option}`}
                      onKeyDownCapture={handleAnswerChange}
                      type={
                        field?.hiden
                          ? options.HasIsadg
                            ? "text"
                            : "hidden"
                          : "text"
                      }
                      className={`form-control`}
                      placeholder={field.displayText}
                      name={field.value}
                      autoComplete="off"
                      readOnly={field?.hidden === true ? true : false}
                      value={
                        searchValues.find(
                          (element) => element.name === field.value
                        )?.value
                      }
                      onChange={(e) => {
                        saveValue(e.target.value, field.value, "text");
                        onInputChange();
                      }}
                      onFocus={(e) => {
                        setcurrentFocus(e.target.value);
                      }}
                      onBlur={(e) => {
                        if (e.target.value !== currentFocus) {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            );
          })}
          {/* renderizando campos select */}
          {colection?.searchfields.map((field) => {
            return (
              <div className="col-12 form-group" key={field.value}>
                {field?.type === "select" && (
                  <div className="mt-3">
                    <label htmlFor="material" className={`${styles.title}`}>{`${field.displayText}`}</label>
                    <Select
                      isMulti={field?.multivalue ? field.multivalue : false}
                      name={field.value}
                      options={field.values}
                      isClearable
                      value={
                        selectedValues.find(
                          (element) => element.value === field.value
                        )?.selectedValues
                      }
                      onChange={async (e) => {
                        await saveValue(e, field.value, "select");
                        changeSelect();
                      }}
                      placeholder={field.placeholder}
                    />
                  </div>
                )}
                {
                  // renderizando campos de fecha
                  field?.type === "date" && (
                    <div className="mt-3">
                      <label htmlFor="material" className={`${styles.title}`}>{`${field.displayText}`}</label>
                      <input
                        className={`${styles.option} form-control`}
                        onKeyDownCapture={handleAnswerChange}
                        type={"date"}
                        placeholder={field.displayText}
                        name={field.value}
                        autoComplete="off"
                        readOnly={field?.hidden === true ? true : false}
                        value={
                          searchValues.find(
                            (element) => element.name === field.value
                          )?.value
                        }
                        onChange={(e) => {
                          saveValue(e.target.value, field.value, "text");
                          onInputChange();
                        }}
                        onFocus={(e) => {
                          setcurrentFocus(e.target.value);
                        }}
                        onBlur={(e) => {
                          if (e.target.value !== currentFocus) {
                            handleSubmit();
                          }
                        }}
                      />
                    </div>
                  )
                }
              </div>
            );
          })}
          {/* renderizando dropDown de idiomas */}
          {/* {colection?.searchfields.map((field) => {
            return (
              <div className="col-12 form-group" key={field.value}>
                {field?.type === "dropDown" && (
                  <div className="mt-3">
                    <LinkList />
                  </div>
                )}
              </div>
            );
          })} */}
        </div>
      )}
    </div>
  );
};

export default SearchOptions;
